import { apiRequest, buildURL } from './commons/CommonService.Functions';

// models
import {
  ExternalEntityAssociationCreateCommand,
  ExternalEntityAssociationUpdateCommand,
  ExternalEntityAssociationViewModel
} from '../models/Entities/Person/ExternalAssociation/ExternalAssociationModels';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons';

// Get all external associations of a person
export const GetExternalAssociationsByPersonId = async (
  token: string,
  personId: number
): Promise<ExternalEntityAssociationViewModel[]> => {
  const requestUrl: string = buildURL(BaseURL, personId, 'external-associations');
  return apiRequest<ExternalEntityAssociationViewModel[]>(
    requestUrl,
    token,
    'GetExternalAssociationsByPersonId'
  );
};

// Get external association by id
export const GetExternalAssociationById = async (
  token: string,
  externalAssociationId: number
): Promise<ExternalEntityAssociationViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'external-associations', externalAssociationId);
  return apiRequest<ExternalEntityAssociationViewModel>(
    requestUrl,
    token,
    'GetExternalAssociationById'
  );
};

// Create external association
export const CreateExternalAssociation = async (
  token: string,
  payload: ExternalEntityAssociationCreateCommand
): Promise<ExternalEntityAssociationViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'external-associations');
  return apiRequest<ExternalEntityAssociationViewModel>(
    requestUrl,
    token,
    'CreateExternalAssociation',
    {
      method: 'POST',
      body: JSON.stringify(payload)
    }
  );
};

// Update external association
export const UpdateExternalAssociation = async (
  token: string,
  payload: ExternalEntityAssociationUpdateCommand
): Promise<ExternalEntityAssociationViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'external-associations', payload.id);
  return apiRequest<ExternalEntityAssociationViewModel>(
    requestUrl,
    token,
    'UpdateExternalAssociation',
    {
      method: 'PUT',
      body: JSON.stringify(payload)
    }
  );
};

// Delete external association
export const DeleteExternalAssociation = async (
  token: string,
  externalAssociationId: number
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, 'external-associations', externalAssociationId);
  return apiRequest<number>(requestUrl, token, 'DeleteExternalAssociation', {
    method: 'DELETE'
  });
};
